import { Navigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import AgentButton from "../../components/Agent";

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { currentUser, userName, loadingProfile } = useAuth();

  if (!currentUser) {
    return <Navigate to="/login" />;
  }

  return (
    <>
      {children}
      {!loadingProfile && <AgentButton userName={userName ?? ""} />}
    </>
  );
};

export default ProtectedRoute;
